import { render, staticRenderFns } from "./MedicineReportConclusion.vue?vue&type=template&id=ca24f1a4"
import script from "./MedicineReportConclusion.vue?vue&type=script&lang=js"
export * from "./MedicineReportConclusion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports